function lineBreaksToBrTag() {
  return function (string) {
    return string.replace(/(?:\r\n|\r|\n)/g, "<br />");
  };
}

export default lineBreaksToBrTag;
